import { eventBus } from './EventBus';
import { PollingTransport } from './transports/pollingTransport';
import type { SystemEventResponse } from '../../types/event.types';

const CHANNEL_NAME = 'clizod-events';
const LEADER_LOCK_NAME = 'clizod-events-leader';

const sleep = (ms: number) =>
    new Promise(resolve => setTimeout(resolve, ms));

export const startEventsSync = (): (() => void) => {
    const channel = new BroadcastChannel(CHANNEL_NAME);

    channel.onmessage = (event: MessageEvent<SystemEventResponse>) => {
        eventBus.publish(event.data);
    };

    // All tabs listen for broadcasted events
    const controller = new AbortController();

    let running = true;

    const runLeader = async (): Promise<void> => {
        try {
            await navigator.locks.request(LEADER_LOCK_NAME, { signal: controller.signal }, async () => {

                if (import.meta.env.DEV) {
                    console.log('[events] leader acquired');
                }

                const transport = new PollingTransport();

                try {
                    transport.connect((message) => {
                        eventBus.publish(message);
                        channel.postMessage(message);
                    });

                    // Keep leadership alive until abort
                    while (running && !controller.signal.aborted) {
                        await sleep(1000);
                    }

                } finally {
                    transport.disconnect();
                    if (import.meta.env.DEV) {
                        console.log('[events] leader released');
                    }
                }
        });
        } catch(error) {
            if (import.meta.env.DEV) {
                console.log('[events] lock request ended', error);
            }
        }
    };

    void runLeader();

    return () => {
        running = false;
        controller.abort();
        channel.close();
    };
};